import UserVideo from "./UserVideo";
import { deleteRequest } from '../../api/shorts-api';

const UserVideos = ({ videos, onDeleteRequest, onVideoClick }) => {
  // Sort videos by createdAt in descending order
  // const sortedVideos = videos.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  const sortedVideos = [...videos].sort((a, b) => new Date(b.date) - new Date(a.date));
  return (
    <div className='draftSection mt-4 pt-5'>
      {/* <h3>Draft</h3> */}
      <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 g-4">
        {sortedVideos.map((video) => (
          <>
          <input type="hidden" name="requestVideoID" value={video.id} />

          <UserVideo
            key={video.id}
            {...video}
            onDelete={() => onDeleteRequest(video.id)}
            onClick={() => onVideoClick(video.id)}
          />
          </>
        ))}
      </div>
    </div>
  );
};

export default UserVideos;
